import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { TagType } from '@constants/vaults/common.constants';

const useStyles = makeStyles<{
  isActive: boolean;
  tagType: TagType | undefined;
  disabled: boolean;
}>()((theme, { tagType, disabled }) => ({
  btn: {
    borderRadius: theme.borderRadius.md,
    border: 'none',
    position: 'relative',
    transition: 'all 0.25s ease-in-out',

    ...(disabled && {
      opacity: 0.5,
    }),

    '&.MuiButtonBase-root': {
      ...dFlex('center', 'center'),
      border: '0px solid transparent',
      background: theme.secondary.s1,
      color: theme.secondary.s3,
      height: 40,
      gap: 4,
      transition: 'none',

      '& .MuiButton-endIcon': {
        width: 16,
        height: 16,
        marginLeft: '4px',
      },

      '& .MuiSvgIcon-root': {
        width: 16,
        height: 16,
        color: theme.secondary.s3,
      },

      '& svg path': {
        fill: theme.secondary.s3,
      },

      '&:hover': {
        color: theme.primary.p2,

        '& .MuiSvgIcon-root': {
          color: theme.primary.p2,
        },

        svg: {
          path: {
            fill: theme.primary.p2,
          },
        },
      },

      '&:focus': {
        color: theme.secondary.s3,

        '& .MuiSvgIcon-root': {
          color: theme.secondary.s3,
        },

        svg: {
          path: {
            fill: theme.secondary.s3,
          },
        },
      },

      '&:active': {
        color: theme.primary.p3,

        '& .MuiSvgIcon-root': {
          color: theme.primary.p3,
        },

        svg: {
          path: {
            fill: theme.primary.p3,
          },
        },
      },
    },
  },
  icon: {
    ...dFlex('center', 'center'),
  },
  activeBtn: {
    '&.MuiButtonBase-root': {
      color: theme.primary.p2,
      background: theme.secondary.s1,
      transition: 'none',

      '& .MuiSvgIcon-root': {
        color: theme.primary.p2,
        width: 16,
        height: 16,
      },

      '& svg': {
        path: {
          fill: theme.primary.p2,
        },
      },

      '&.MuiButtonBase-root:hover': {
        color: theme.primary.p3,
        background: theme.secondary.s1,
        transition: 'none',

        '& .MuiSvgIcon-root': {
          color: theme.primary.p3,
        },

        svg: {
          path: {
            fill: theme.primary.p3,
          },
        },
      },

      '&:focus': {
        color: theme.primary.p2,
        background: theme.secondary.s1,

        '& .MuiSvgIcon-root': {
          color: theme.primary.p2,
        },

        svg: {
          path: {
            fill: theme.primary.p2,
          },
        },
      },

      '&:active': {
        color: theme.secondary.s3,
        background: theme.secondary.s1,

        '& .MuiSvgIcon-root': {
          color: theme.secondary.s3,
        },

        svg: {
          path: {
            fill: theme.secondary.s3,
          },
        },
      },
    },
  },
  tagType: {
    ...dFlex(),
    position: 'absolute',
    borderRadius: theme.borderRadius.sm,
    padding: '0 4px',
    textTransform: 'initial',
    color: theme.primary.p2,
    right: '5%',
    top: '0%',
    transform: 'translate(0, -50%)',

    ...(tagType === TagType.New && {
      background: theme.gradient.g2,
    }),
  },
}));

export default useStyles;
